import routeInfoOfName from 'rise-ui/utils/route-info-of-name.js';

const cacheRoutes = [
  'time-series',
  'catalog',
];

// Configure on which routes time-series data cache should be maintained
export function initialize(appInstance) {
  const router = appInstance.lookup('service:router');
  const timeSeriesLocations = appInstance.lookup('service:time-series/selected-locations');
  const locationFilters = appInstance.lookup('service:store/location-filters');
  router.on('routeDidChange', transition => {
    const routeInfo = routeInfoOfName(transition.to, cacheRoutes);
    if (!routeInfo) {
      // TODO see if this is still needed
      // timeSeriesLocations.clearAll();
      // locationFilters.clearAll();
    }
  });
}

export default {
  initialize,
};
